import { useState } from 'react'

import type { PhaseInfo, WorkflowStage } from '../../types/workflow'
import { getTextVariable } from './template-variable-utils'

interface TextAreaTemplateProps {
  stage: WorkflowStage
  onNext: (answers: Record<string, unknown>) => void
  initialValue?: string
  currentPhase?: PhaseInfo | null
}

export default function TextAreaTemplate({
  stage,
  onNext,
  initialValue = '',
  currentPhase,
}: TextAreaTemplateProps) {
  const header = getTextVariable(stage.templateVariables, 'header', "Anything else you'd like your provider to know?")
  const subHeader = getTextVariable(stage.templateVariables, 'subHeader', '')
  const placeholder = getTextVariable(stage.templateVariables, 'placeholder', 'Share any concerns, questions, or observations…')
  const optionalStr = getTextVariable(stage.templateVariables, 'optional', 'true')
  const optional = optionalStr === 'true'
  const buttonText = getTextVariable(stage.templateVariables, 'button_text', 'Continue')
  const answerField = stage.answerMapping?.field || stage.name

  const [value, setValue] = useState(initialValue)
  const canContinue = optional ? true : value.trim().length > 0

  return (
    <div className="flex-1 flex flex-col gap-4">

      <div className="quiz-body flex-1">
        <div className="rounded-2xl bg-[var(--ww-surface)] p-5">
          <textarea
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            className="min-h-[160px] w-full resize-none rounded-xl border border-[var(--ww-glass-border,rgba(255,255,255,0.08))] bg-[var(--ww-surface,var(--field-color))] px-4 py-4 text-[var(--ww-text,#fff)] outline-none placeholder:text-[var(--ww-text-3)] focus:border-[var(--ww-accent,var(--line-border-hover))]"
          />
          {optional && (
            <p className="mt-2 text-[12px] text-white/40">Optional — you can leave this blank.</p>
          )}
        </div>
      </div>

      <div className="mt-auto pt-6 pb-2 -ml-[42px] w-[calc(100%+42px)]">
        <button
          onClick={() => onNext({ [answerField]: value })}
          disabled={!canContinue}
          className="w-full py-4 px-6 text-[15px] font-semibold text-[var(--ww-btn-text)] bg-[var(--ww-btn-bg)] border-none rounded-full cursor-pointer transition-all duration-300 shadow-[0_2px_8px_rgba(0,0,0,0.1)] hover:not-disabled:bg-[var(--ww-btn-hover)] hover:not-disabled:-translate-y-0.5 disabled:opacity-25 disabled:cursor-default"
        >
          {buttonText}
        </button>
      </div>
    </div>
  )
}
